export const getContextInfo = (state) => state.renderer.contextInfo
export const getHasRendered = (state) => state.renderer.hasRendered
export const getIsLowPerformance = (state) => state.renderer.isLowPerformanceDevice
